import React, { Component } from 'react';
import { authContext } from '../adalConfig';
import axios from 'axios';
import './react-datetime.css';
import 'react-table/react-table.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import './MonthlyView.css';
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from './csvSanitizer';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Modal from 'react-modal';
import * as appsettings from './constants';
import ReactDOM from 'react-dom';
import DateTime from 'react-datetime';
import './react-datetime.css';
import TelemetryDetailModal from './TelemetryDetailModal';

// Computes the severity ('green' | 'orange' | 'red' | null) of a metric value
// for the currently-selected metric type, mirroring the ARP cell coloring logic.
function getMetricSeverity(metricType, value) {
    const v = Number(value);
    if (!v || v <= 0) {
        return null;
    }
    if (metricType === 'Availability') {
        if (v >= appsettings.AvailabilityLegacyGreenTarget) return 'green';
        if (v >= appsettings.AvailabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (metricType === 'Reliability') {
        if (v >= appsettings.ReliabilityGreenTarget) return 'green';
        if (v >= appsettings.ReliabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (metricType === 'Performance') {
        if (v >= appsettings.PerformanceGreenTarget) return 'green';
        if (v >= appsettings.PerformanceOrangeTarget) return 'orange';
        return 'red';
    }
    return null;
}

export class WeeklyView extends Component {
    displayName = WeeklyView.name
    constructor(props) {
        super(props);
        this.today = new Date();
        this.exceptionDate = new Date();
        this.exceptionDate.setUTCFullYear(1950);
        this.today.setDate(this.today.getDate() - 1);
        this.today.setHours(5);
        this.today.setMinutes(30);
        this.today.setSeconds(0);
        this.tomorrow = new Date();
        this.tomorrow.setDate(this.tomorrow.getDate());
        this.tomorrow.setHours(5);
        this.tomorrow.setMinutes(30);
        this.tomorrow.setSeconds(0);
        this.state = {
            TempData: [], datatobeshown: appsettings.datatobeshown[0],
            month: 0, year: 0,
            greenFont: appsettings.ReliabilityGreenTarget,
            Columns: [], Metric: [],
            metricType: appsettings.metricTypes[0],
            environment: appsettings.options[0],
            loading: false, modalIsOpen: false, userId: '',
            DSMService: '', Service: '', ComponentName: '',
            SelectedMonthandYear: '',
            selectedRow: '', selectedColumn: '',
            fromDate: this.today.toISOString(), toDate: this.tomorrow.toISOString(),
            exceptionDate: this.exceptionDate.toISOString(),
            weekdays:[],
            detailModalOpen: false, detailLoading: false, detailError: false, detailData: [],
            detailSeverity: 'orange', detailAppname: '', detailComponent: '', detailService: '', detailDSMService: '',
            detailMetricType: '', detailMetricValue: '', detailTimeRange: ''
        };        
        this.onMetricCellClick = this.onMetricCellClick.bind(this);
        this.closeDetailModal = this.closeDetailModal.bind(this);
    }
    // Formats the selected week (UTC) as e.g. "Aug 04 - Aug 10, 2026 UTC".
    formatWeekRange(startIso, endExclusiveIso) {
        const opts = { month: 'short', day: '2-digit', timeZone: 'UTC' };
        const start = new Date(startIso);
        const endIncl = new Date(new Date(endExclusiveIso).getTime() - 24 * 60 * 60 * 1000);
        const year = endIncl.toLocaleDateString('en-US', { year: 'numeric', timeZone: 'UTC' });
        return start.toLocaleDateString('en-US', opts) + ' - ' + endIncl.toLocaleDateString('en-US', opts) + ', ' + year + ' UTC';
    }
    // Collapses duplicate URLs into one row with summed failures, sorted desc.
    aggregateByUrl(records) {
        const map = new Map();
        for (let i = 0; i < records.length; i++) {
            const r = records[i];
            const rawUrl = (r.Url || '').trim();
            if (!rawUrl) { continue; }
            const normalizedUrl = rawUrl.replace(/\/+$/, '').toLowerCase();
            const method = (r.HttpMethod || 'UNKNOWN').trim().toUpperCase();
            const key = `${normalizedUrl}::${method}`;
            const count = Number(r.FailureCount) || 0;
            if (map.has(key)) {
                map.get(key).FailureCount += count;
            } else {
                map.set(key, Object.assign({}, r, {
                    Url: rawUrl,
                    HttpMethod: method === 'UNKNOWN' ? '' : method,
                    FailureCount: count
                }));
            }
        }
        return Array.from(map.values()).sort((a, b) => b.FailureCount - a.FailureCount);
    }
    componentDidMount() {
        this.Getlastweekdates();
        this.getData(this.state.metricType.value, this.state.environment.value);
        var user = authContext.getCachedUser();
        var userId = user.userName;
        var domainIndex = userId.indexOf('@microsoft.com');
        userId = userId.substr(0, domainIndex);
        this.setState({
            userId: userId
        })
    }

    getData(metric, environment) {
        this.Getlastweekdates();
        this.setState({
            loading: true
        });
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink =  "api/CosmosApi/Getlastweek/?startdate='" + this.state.fromDate + "'&metricType=" + metric + "&environment=" + environment;   
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Metric: response.data,
                TempData: response.data
            });
        });

    }
    
    Getlastweekdates() {
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink =  "api/CosmosApi/Getlastweekdates/?startdate='" + this.state.fromDate + "'";
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                weekdays: response.data
            });   
        });
        
    }
    updateFromDate(date) {
        try {
            this.setState({
                fromDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate,
                toDate: this.state.exceptionDate
            });

        }
    }
   
    onSelectEnvironment(event) {
        this.setState({
            environment: event
        });
        this.getData(this.state.metricType.value, event.value);
    }
    onSelectmetricType(event) {
        this.setState({
            metricType: event
        });
        this.getData(event.value, this.state.environment.value);

        if (event.value === "Performance") {
            this.setState({
                greenFont: appsettings.PerformanceGreenTarget
            });
        }
        else if (event.value === "Availability") {
            this.setState({
                greenFont: appsettings.AvailabilityGreenTarget
            });
        }
        else {
            this.setState({
                greenFont: appsettings.ReliabilityGreenTarget
            });
        }
    }
    callgetData() {
        this.getData(this.state.metricType.value, this.state.environment.value);
    }
    onMetricCellClick(rowData, accessor, severity) {
        const metricType = this.state.metricType.value;
        const appname = rowData.appname || rowData.Component || '';
        // Scope the URL-failure details to the selected week. The week spans the
        // 7 day-columns shown: the fromDate day back through fromDate - 6 days.
        const src = new Date(this.state.fromDate);
        const day = new Date(Date.UTC(src.getUTCFullYear(), src.getUTCMonth(), src.getUTCDate()));
        const weekStart = new Date(day.getTime());
        weekStart.setUTCDate(weekStart.getUTCDate() - 6);
        const weekEnd = new Date(day.getTime());
        weekEnd.setUTCDate(weekEnd.getUTCDate() + 1);
        this.setState({
            detailModalOpen: true,
            detailLoading: true,
            detailError: false,
            detailData: [],
            detailSeverity: severity,
            detailAppname: appname,
            detailComponent: rowData.Component || '',
            detailService: rowData.Service || '',
            detailDSMService: rowData.DSMService || '',
            detailMetricType: metricType,
            detailMetricValue: rowData[accessor]
        });
        this.setState({ detailTimeRange: this.formatWeekRange(weekStart.toISOString(), weekEnd.toISOString()) });
        this.fetchUrlFailureDetails(appname, this.state.environment.value, metricType, weekStart.toISOString(), weekEnd.toISOString());
    }
    fetchUrlFailureDetails(appname, environment, metricType, startDate, endDate) {
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink = "api/CosmosApi/GetUrlFailureDetails/?appname=" + encodeURIComponent(appname)
            + "&environment=" + encodeURIComponent(environment)
            + "&metricType=" + encodeURIComponent(metricType);
        if (startDate && endDate) {
            apilink += "&startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate);
        }
        axios.get(apilink, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            var data = response.data;
            if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = []; }
            }
            if (!Array.isArray(data)) { data = []; }
            this.setState({
                detailLoading: false,
                detailError: false,
                detailData: this.aggregateByUrl(data)
            });
        }).catch(err => {
            console.error('GetUrlFailureDetails failed', err);
            this.setState({
                detailLoading: false,
                detailError: true,
                detailData: []
            });
        });
    }
    closeDetailModal() {
        this.setState({ detailModalOpen: false });
    }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {       
        var columns = [
            { Header: appsettings.DSMService, accessor: 'DSMService', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: appsettings.Service, accessor: 'Service', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: appsettings.ComponentHeader, accessor: 'Component', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: this.state.weekdays[0], accessor: 'data7', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data7 >= this.state.greenFont ? "green" : rowInfo.row.data7 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[1], accessor: 'data6', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data6 >= this.state.greenFont ? "green" : rowInfo.row.data6 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[2], accessor: 'data5', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data5 >= this.state.greenFont ? "green" : rowInfo.row.data5 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[3], accessor: 'data4', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data4 >= this.state.greenFont ? "green" : rowInfo.row.data4 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[4], accessor: 'data3', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data3 >= this.state.greenFont ? "green" : rowInfo.row.data3 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[5], accessor: 'data2', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data2 >= this.state.greenFont ? "green" : rowInfo.row.data2 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: this.state.weekdays[6], accessor: 'data1', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data1 >= this.state.greenFont ? "green" : rowInfo.row.data1 > 0 ? "red" : "white" } }; }, width: 80 }
        ];

        var csvHeaders = [
            { label: appsettings.DSMService, key: 'DSMService' },
            { label: appsettings.Service, key: 'Service' },
            { label: appsettings.ComponentHeader, key: 'Component' },
            { label: this.state.weekdays[0], key: 'data7' },
            { label: this.state.weekdays[1], key: 'data6' },
            { label: this.state.weekdays[2], key: 'data5' },
            { label: this.state.weekdays[3], key: 'data4' },
            { label: this.state.weekdays[4], key: 'data3' },
            { label: this.state.weekdays[5], key: 'data2' },
            { label: this.state.weekdays[6], key: 'data1' }
        ]
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.WeeklyViewHeader}</h4>
                </div>
                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <div id='starttime'>Metric Type:</div>
                    <Dropdown className='metricType' options={appsettings.metricTypes} onChange={this.onSelectmetricType.bind(this)} value={this.state.metricType} placeholder="Select an option" />
                    <div id='starttime'>Start Time:</div>
                    <DateTime className='FromDate' closeOnSelect={true} onBlur={this.updateFromDate.bind(this)} utc={true} defaultValue={this.today} />
                    <button id='GetKPIsButton' onClick={this.callgetData.bind(this)} data-tooltip="Fetch Data">GetKPIs</button>
                    <CSVLink data={sanitizeCsvData(this.state.Metric)} filename={"CSTelemetry.csv"} headers={csvHeaders} className="csvExport">Export to csv</CSVLink>

                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                        style={{ marginLeft: '10px' }}
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />

                <p id='target'>Target : Availability: &gt;={appsettings.AvailabilityGreenTarget}%, Reliability: &gt;={appsettings.ReliabilityGreenTarget}%, Performance: &gt;={appsettings.PerformanceGreenTarget}%  </p>
                <p className='AddComment'>Data might take some time to load</p>
                <ReactTable
                    data={this.state.Metric}
                    columns={columns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.state.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={(state, rowInfo, column, instance) => {
                        const accessor = column ? (column.id || column.accessor) : null;
                        const isMetric = accessor && accessor.indexOf('data') === 0;
                        let severity = null;
                        if (isMetric && rowInfo && rowInfo.row) {
                            severity = getMetricSeverity(this.state.metricType.value, rowInfo.row[accessor]);
                        }
                        const clickable = !!(isMetric && (severity === 'orange' || severity === 'red'));
                        return {
                            title: clickable ? 'Click to view the URL failures causing this dip' : undefined,
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '1px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap',
                                background: rowInfo && rowInfo.index === this.state.selected ? '#96B1C7' : '',
                                cursor: clickable ? 'pointer' : 'default',
                                textDecoration: clickable ? 'underline' : 'none'
                            },
                            onClick: () => {
                                if (clickable && rowInfo && rowInfo.original) {
                                    this.onMetricCellClick(rowInfo.original, accessor, severity);
                                }
                            }
                        };
                    }}
                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '14px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}
                />
                <TelemetryDetailModal
                    isOpen={this.state.detailModalOpen}
                    onRequestClose={this.closeDetailModal}
                    severity={this.state.detailSeverity}
                    appname={this.state.detailAppname}
                    component={this.state.detailComponent}
                    service={this.state.detailService}
                    dsmService={this.state.detailDSMService}
                    metricType={this.state.detailMetricType}
                    metricValue={this.state.detailMetricValue}
                    environment={this.state.environment.value}
                    loading={this.state.detailLoading}
                    error={this.state.detailError}
                    details={this.state.detailData}
                    timeRange={this.state.detailTimeRange}
                />
               
            </div>
        );
    }
}
